/**
 * CardErrorState.js
 *
 * Componente padronizado para estado de erro dos cards do Executive Dashboard.
 * Exibe ícone de erro e mensagem centralizada.
 */

import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    minHeight: (props) => props.minHeight || 180,
    padding: theme.spacing(2),
    backgroundColor: "rgba(244, 67, 54, 0.04)",
    borderRadius: theme.shape.borderRadius,
  },
  icon: {
    fontSize: 40,
    color: theme.palette.error.light,
    marginBottom: theme.spacing(1),
  },
  message: {
    color: theme.palette.error.main,
    textAlign: "center",
    fontSize: "0.875rem",
  },
  details: {
    color: theme.palette.text.secondary,
    textAlign: "center",
    fontSize: "0.75rem",
    marginTop: theme.spacing(0.5),
  },
}));

/**
 * CardErrorState - Estado de erro padronizado
 *
 * @param {string} message - Mensagem de erro principal
 * @param {string} details - Detalhes adicionais (opcional)
 * @param {number} minHeight - Altura mínima do container
 */
export default function CardErrorState({
  message = "Erro ao carregar dados",
  details = null,
  minHeight = 180,
}) {
  const classes = useStyles({ minHeight });

  return (
    <Box className={classes.container}>
      <ErrorOutlineIcon className={classes.icon} />
      <Typography className={classes.message}>{message}</Typography>
      {details && (
        <Typography className={classes.details}>{details}</Typography>
      )}
    </Box>
  );
}

CardErrorState.propTypes = {
  message: PropTypes.string,
  details: PropTypes.string,
  minHeight: PropTypes.number,
};
